import useSWR from "swr";

export function useCreditHistories() {
  const { data, error } = useSWR("/credit-history");
  return {
    credit: data?.content,
    isLoading: data === undefined,
  };
}
